module.exports = __webpack_public_path__ + "img/equipment-icon-tk.a9fb9dc1.png";